import React from 'react';
import cns from 'classnames';
import Button from 'react-bootstrap/Button';
import styles from './button.module.scss';
export function OutlineButton({ children, className, ...props }) {
  const buttonClasses = cns(styles.buttonOutline, className);
  return (
    <Button variant="outline-primary" className={buttonClasses} {...props}>
      {children}
    </Button>
  );
}
export function PrimaryButton({ children, className, ...props }) {
  const buttonClasses = cns(styles.primaryButton, className);
  return (
    <Button variant="primary" className={buttonClasses} {...props}>
      {children}
    </Button>
  );
}
export function EmptyButton({ children, className, ...props }) {
  const buttonClasses = cns(styles.emptybtn, className);
  return (
    <Button className={buttonClasses} {...props}>
      {children}
    </Button>
  );
}
